// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.footer[data-v-c78bb722] {\n  flex-shrink: 0;\n  z-index: 1030;\n  min-height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
